import { Label } from "reactstrap";
import { AnnualFunction, Location } from "../../../../Constant";
import { H5, LI, P } from "../../../../AbstractElements";

export const AnnualFunctionHoveringTimeline = () => {
  return (
    <LI className="timeline-event">
      <Label className="timeline-event-icon"></Label>
      <div className="timeline-event-wrapper">
        <P className="timeline-thumbnail">{AnnualFunction}</P>
        <H5>{Location}</H5>
        <span className="text-muted">Largo Febo,10225012-Calvisano BS</span>
        <P className="pt-3 mb-4">What a dynamic performance by the eighth-grade students, Let's welcome the ninth-grade kid to the stage.</P>
      </div>
    </LI>
  );
};
